module.exports = __webpack_public_path__ + "img/logo-head.5ecf5f1c.png";